import React from 'react';
import { RecommendationsCarouselFree } from '@recommendations-fe/carousel-free';
import { RecommendationsCardVertical } from '@recommendations-fe/card';
import { IconFactory } from '@recommendations-fe/icons';
import { RecommendationsCarouselSnapped } from '@recommendations-fe/carousel-snapped';
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
var REACT_ELEMENT_TYPE;
function _createRawReactElement(e, r, E, l) {
  REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol["for"] && Symbol["for"]("react.element") || 60103);
  var o = e && e.defaultProps,
    n = arguments.length - 3;
  if (r || 0 === n || (r = {
    children: void 0
  }), 1 === n) r.children = l;else if (n > 1) {
    for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];
    r.children = t;
  }
  if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});
  return {
    $$typeof: REACT_ELEMENT_TYPE,
    type: e,
    key: void 0 === E ? null : "" + E,
    ref: null,
    props: r,
    _owner: null
  };
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
var _excluded$1 = ["lazyLoad", "carouselProps"];
var RecommendationCarouselMobile = function RecommendationCarouselMobile(props) {
  var lazyLoad = props.lazyLoad;
  props.carouselProps;
  var rest = _objectWithoutProperties(props, _excluded$1);
  return /*#__PURE__*/_createRawReactElement(RecommendationsCarouselFree, {
    Card: RecommendationsCardVertical,
    IconFactory: IconFactory,
    apiresponse: rest,
    lazyLoad: lazyLoad,
    lazy: false
  });
};
RecommendationCarouselMobile.defaultProps = {
  carouselProps: {},
  lazyLoad: true
};
var RecommendationsCarouselMobile = RecommendationCarouselMobile;
var _excluded = ["lazyLoad", "carouselProps"];
const RecommendationCarouselDesktop = /*#__PURE__*/function () {
  const RecommendationCarouselDesktop = function RecommendationCarouselDesktop(props) {
    var lazyLoad = props.lazyLoad,
      carouselProps = props.carouselProps,
      rest = _objectWithoutProperties(props, _excluded);
    return /*#__PURE__*/React.createElement(RecommendationsCarouselSnapped, _extends({
      Card: RecommendationsCardVertical,
      IconFactory: IconFactory,
      apiresponse: rest,
      lazyLoad: lazyLoad,
      lazy: false
    }, carouselProps));
  };
  RecommendationCarouselDesktop.defaultProps = {
    carouselProps: {},
    lazyLoad: true
  };
  return RecommendationCarouselDesktop;
}();
var RecommendationCarouselDesktop$1 = RecommendationCarouselDesktop;
var DEVICE_TYPE_DESKTOP = 'desktop';
const RecommendationCarousel = /*#__PURE__*/function () {
  const RecommendationCarousel = function RecommendationCarousel(_ref) {
    var deviceType = _ref.deviceType,
      recommendations = _ref.recommendations,
      carouselProps = _ref.carouselProps;
    return deviceType === DEVICE_TYPE_DESKTOP ? /*#__PURE__*/React.createElement(RecommendationCarouselDesktop$1, _extends({}, recommendations, {
      carouselProps: carouselProps
    })) : /*#__PURE__*/React.createElement(RecommendationsCarouselMobile, _extends({}, recommendations, {
      carouselProps: carouselProps
    }));
  };
  RecommendationCarousel.defaultProps = {
    carouselProps: {}
  };
  return RecommendationCarousel;
}();
var RecommendationCarousel$1 = RecommendationCarousel;
export { RecommendationCarousel$1 as default };
